// import { border } from "@material-ui/system";

const styles = () => ({
  root: {
    maxHeight: "calc(100vh - 135px)",
    height: "auto",
    overflow: "auto",
  },
  newEventButton: {
    height: 32,
    padding: '6px 16px',
    background: '#26BBED',
    borderRadius: 0,
    color: 'white',
    boxShadow: 'none',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.75,
    textTransform: "none",
    '&:hover': {
      background: '#26BBEDEE'
    }
  },
  newButton: {
    lineHeight: "initial"
  },
  eventListWrapper: {
    padding: 20,
    background: "#f9f9f9",
    minHeight: "calc(100vh - 135px)",
    display: 'flex',
    flexFlow: 'column',
    paddingBottom: 20,
  },
  eventFiltersWrapper: {
    padding: '15px 20px',
    background: '#fff',
    border: "1px solid #dbd9d9",
  },
  noEventsWrapper: {
    // flexGrow: 1,
    // background: "#fff",
    display: 'flex',
    // flexDirection: 'column',
    height: "74vh",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  noEventsText: {
    marginTop: 16
  },
  eventsListWrapper: {
    marginTop: 0,
  },
  modalTextArea: {
    height: 90,
    background: '#fff'
  },
  cancelButton: {
    color: '#333',
    borderRadius: 0,
    borderColor: '#999',
    fontSize: 14,
    fontWeight: 600
  },
  closeCancelModal: {
    color: '#333',
    borderRadius: 0,
    fontSize: 14,
    fontWeight: 600
  },
  description: {
    fontSize: 16,
    fontWeight: 400
  },
  cancelFieldLabel: {
    marginBottom: 4,
    marginTop: 24
  },
  cancelField: {
    borderRadius: 'none',
    border: '1px solid #dadada',
    padding: 12
  },
  searchBox: {
    width: 140,
  },
  verticalDivider: {
    marginLeft: 12,
    marginRight: 12
  },
  imageOpacity: {
    opacity: 0.3,
    display: "block",
    margin: "auto"
  },
  filterClass: {
    height: 24,
    width: 24,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      color: "#26bbed"
    }
  },
  filterEnableClass: {
    background: "rgba(38, 187, 237, 0.06)",
  },
  loadMore: {
    height: 60,
    background: '#FFFFFF',
    border: "1px solid #DADADA",
    fontWeight: 600,
    fontSize: 14,
    fontFamily: "Open Sans",
    fontStyle: "normal",
    marginTop: 24,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      background: "#f4fbfd"
    }
  },
  remainingRowWidth: {
    width: 290,
  }
});

export default styles;